import { InputCampaignThumbController } from './input-campaign-thumb.controller'

function inputCampaignThumb () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      thumbUrl: '<'
    },
    templateUrl: '/admin/directives/input-campaign-thumb/input-campaign-thumb-directive.html?$$REVISION$$',
    controller: InputCampaignThumbController
  }
}

export { inputCampaignThumb }
